export var AccountType;
(function (AccountType) {
    AccountType["USER"] = "user";
    AccountType["SYSTEM"] = "system";
    AccountType["MAINTENANCE"] = "maintenance";
})(AccountType || (AccountType = {}));
//# sourceMappingURL=types.js.map